import moment from 'moment'

type ETAAddress = {
    estimatedTimeOfArrival?: string
    plannedTimeOfArrival?: string
}

/**
 * ETA deviation of a started route in minutes, measured at the next stop: positive is a delay, negative a lead.
 * Returns null when there is nothing to compare, e.g. a route without start time has no planned arrival times.
 * Used by both the messenger app and the planning, so the messenger and the planner see the same number.
 */
export function getETADeviation(route: {addresses?: ETAAddress[]} | undefined | null): number | null {
    const nextAddress = route?.addresses?.[0]

    if (!nextAddress?.estimatedTimeOfArrival || !nextAddress?.plannedTimeOfArrival) {
        return null
    }

    const deviation = moment(nextAddress.estimatedTimeOfArrival, 'HH:mm').diff(moment(nextAddress.plannedTimeOfArrival, 'HH:mm'), 'minutes')

    return Number.isFinite(deviation) ? deviation : null
}

/**
 * Deviation as a time, e.g. '+ 01:05' for a delay of 65 minutes and '- 00:12' for a lead of 12 minutes.
 * No deviation is shown as '- 00:00'.
 */
export function formatETADeviationTime(deviation: number | null): string {
    const minutes = deviation || 0
    const absMinutes = Math.abs(minutes)

    const hours = String(Math.floor(absMinutes / 60)).padStart(2, '0')
    const rest = String(absMinutes % 60).padStart(2, '0')

    return `${minutes > 0 ? '+' : '-'} ${hours}:${rest}`
}
